import { IWhitelabelContext } from 'main/framework'
import { INavContext } from 'main/hooks/useSSOContext'
import { userDashboardPath } from 'main/routes'
import { buildAuthBranding } from 'main/util/asset'
import {
  AuthFlowType,
  getDirectorJoinMode,
  getJoinMode,
  getLoginMode,
  getLogoutMode,
  getParentJoinMode,
  getReturnState,
} from 'main/util/ssoTracking'
import { UserType } from 'main/util/user'

import { BRANDING_STATE_KEY, IUserPayload } from '@wonderschool/common-base-sso'
import { BASE_DOMAIN } from 'config'
import WSA from 'sdk/sso'

import { ISSOTrackingProps } from './types'

export interface IObjectAny {
  [key: string]: any
}

export interface IReturnPayload extends ISSOTrackingProps {
  type?: UserType
  user?: IUserPayload
  isSignup?: boolean
  signupData?: IObjectAny
  isSignin?: boolean
  signinData?: IObjectAny
  mode?: AuthFlowType
  networkId?: string
  invitationId?: string
  nav?: INavContext
  [key: string]: any
}

export const getWhitelabelBranding = (whitelabelCtx: IWhitelabelContext) => {
  return whitelabelCtx.isWhitelabeled
    ? {
        [BRANDING_STATE_KEY]: buildAuthBranding(whitelabelCtx),
      }
    : {}
}

const getAllState = (
  trackingProps: ISSOTrackingProps,
  navCtx?: INavContext,
  extra?: IObjectAny,
) => {
  const bestExtra = extra || trackingProps.extraData
  return {
    ...(!!navCtx ? { nav: { ...navCtx } } : {}),
    ...getReturnState(trackingProps),
    ...(!!bestExtra ? bestExtra : {}),
  }
}

export const getUntypedJoinUrl = (
  trackingProps: ISSOTrackingProps,
  navCtx?: INavContext,
  extra?: IObjectAny,
  userType?: UserType,
) => {
  return WSA.URLs.getSignup({
    ...getAllState(trackingProps, navCtx, extra),
    ...getJoinMode(userType),
  })
}
export const getUntypedJoinUrlNoNav = (
  trackingProps: ISSOTrackingProps,
  extra?: IObjectAny,
  userType?: UserType,
) => {
  return getUntypedJoinUrl(trackingProps, undefined, extra, userType)
}

export const getDirectorJoinUrl = (
  trackingProps: ISSOTrackingProps,
  navCtx?: INavContext,
  extra?: IObjectAny,
) => {
  return WSA.URLs.getSignup({
    ...getAllState(trackingProps, navCtx, extra),
    ...getDirectorJoinMode(),
  })
}

export const getParentJoinUrl = (
  trackingProps: ISSOTrackingProps,
  navCtx?: INavContext,
  extra?: IObjectAny,
) => {
  return WSA.URLs.getSignup({
    ...getAllState(trackingProps, navCtx, extra),
    ...getParentJoinMode(),
  })
}

export const getLoginUrl = (
  trackingProps: ISSOTrackingProps,
  navCtx?: INavContext,
  extra?: IObjectAny,
  userType?: UserType,
  noSignupMode?: boolean,
) => {
  return WSA.URLs.getSignin(
    {
      ...getAllState(trackingProps, navCtx, extra),
      ...getLoginMode(userType),
    },
    noSignupMode,
  )
}
export const getLoginUrlNoNav = (
  trackingProps: ISSOTrackingProps,
  extra?: IObjectAny,
  userType?: UserType,
) => {
  return getLoginUrl(trackingProps, undefined, extra, userType)
}
export const getParentLoginResetUrl = () => {
  return getLoginUrl({}, undefined, undefined, UserType.Parent)
}

export const getLogoutUrl = (whitelabelCtx: IWhitelabelContext) => {
  return WSA.URLs.getSignout(
    {
      ...getLogoutMode(),
      ...getWhitelabelBranding(whitelabelCtx),
    },
    `${BASE_DOMAIN}${userDashboardPath()}`,
  )
}
